import { createReducer, on } from '@ngrx/store';
import { setTaskState } from './task.actions';
import { AppointmentForm } from '@core/models/interfaces/task';

export interface TaskState {
  isEditTask: boolean;
  taskId: string;
  viewMode: 'LIST' | 'APPOINTMENT';
  startDate?: Date;
  endDate?: Date;
  appointmentForm?: Partial<AppointmentForm>; // Lưu toàn bộ form data để có thể restore lại
}

const initialState: TaskState = {
  isEditTask: false,
  taskId: '',
  viewMode: 'LIST'
};

export const taskReducer = createReducer(
  initialState,
  on(setTaskState, (state, { isEditTask, taskId, viewMode, startDate, endDate, appointmentForm }) => ({
    ...state,
    isEditTask,
    taskId,
    startDate,
    endDate,
    viewMode,
    appointmentForm: appointmentForm !== undefined ? appointmentForm : state.appointmentForm // Giữ lại form data nếu không được truyền vào
  }))
);
